import React, { useRef } from "react";
import { WagmiProvider } from "wagmi";
import { Toaster } from "sonner";
import { wagmiConfig } from "./config/wagmi";
import Navbar from "./components/Navbar";
import HeroBoard from "./components/HeroBoard";
import SlotMachine from "./components/SlotMachine";
import WinnersMarquee from "./components/WinnersMarquee";
import About from "./components/About";
import { LOGO_URL } from "./components/Brand";
import { VAULT_ADDRESS } from "./config/contracts";

function NotStartedBanner() {
  if (VAULT_ADDRESS) return null;
  return (
    <div
      data-testid="banner-not-started"
      className="relative z-20 mx-6 md:mx-10 mt-4 px-5 py-3 rounded-2xl flex items-center justify-center gap-3 text-sm md:text-base"
      style={{
        background: "linear-gradient(90deg, rgba(243,186,47,0.18), rgba(22,160,101,0.18))",
        border: "1px solid rgba(243,186,47,0.45)",
        boxShadow: "0 8px 32px -12px rgba(243,186,47,0.35)",
      }}
    >
      <span className="text-xl">⏳</span>
      <span className="font-display text-amber-200">活动未开始</span>
      <span className="text-emerald-100/70 hidden md:inline">·</span>
      <span className="text-emerald-100/80">金库尚未上线，敬请期待开奖时刻 🎋</span>
    </div>
  );
}

function Footer() {
  return (
    <footer className="relative z-10 mt-16 mb-8 px-6 md:px-10">
      <div className="glass-dark py-6 px-6 md:px-10 flex flex-col md:flex-row items-center md:items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="" className="w-10 h-10 rounded-full opacity-80" />
          <div>
            <div className="font-display text-amber-300 text-lg">幸运粽子 · LuckyZongzi</div>
            <div className="text-[11px] text-emerald-100/60">FLAP 生态首个链上 VRF 公平抽奖金库 · BNB Smart Chain</div>
          </div>
        </div>
        <div className="text-[11px] text-emerald-100/50 text-center md:text-right">
          <div className="flex items-center justify-center md:justify-end gap-3 mb-2">
            <a
              href="https://x.com/LUCKYZONGZI"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-x-link"
              className="inline-flex items-center gap-2 text-amber-300 hover:text-white transition"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z"/>
              </svg>
              <span className="text-xs">@LUCKYZONGZI</span>
            </a>
            <span className="text-emerald-100/30">·</span>
            {VAULT_ADDRESS && (
              <a href={`https://bscscan.com/address/${VAULT_ADDRESS}`} target="_blank" rel="noreferrer" className="underline hover:text-amber-300 text-xs">BscScan ↗</a>
            )}
          </div>
          <div className="mt-1">免责声明：抽奖完全免费，奖金来自代币交易税，参与即视为知悉链上风险</div>
        </div>
      </div>
    </footer>
  );
}

function AppContent() {
  const slotRef = useRef(null);
  const onScrollToSlot = () => {
    document.getElementById("slot")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <>
      <Navbar />
      <main className="relative">
        <NotStartedBanner />
        <HeroBoard onScrollToSlot={onScrollToSlot} />
        <SlotMachine ref={slotRef} />
        <WinnersMarquee />
        <About />
        <Footer />
      </main>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "linear-gradient(135deg, rgba(13, 92, 58, 0.95), rgba(10, 37, 64, 0.95))",
            color: "#F5F7F6",
            border: "1px solid rgba(243, 186, 47, 0.5)",
          },
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <AppContent />
    </WagmiProvider>
  );
}
